module.exports = __webpack_public_path__ + "img/joinQuestion.e3474255.png";